var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-placeholder"},[_c('spinner'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('CONVERSATION.CARD_CONTEXT_MENU.AGENTS_LOADING')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }